import React from 'react';
import Lookup from '../componentes/select2';
import { autobind } from 'core-decorators';

@autobind
class TipoValorFaixa extends React.Component {
  render() {
    return <Lookup clearable={false} labelKey="descricao" valueKey="id" url="/TipoValorFaixaLookup" {...this.props} />;
  }
}

export default TipoValorFaixa;
